import { AppSignature } from "src/app/models/app-signature";
import { Board, GradeModel } from "src/app/models/master.model";
import { GradeSubjectDTO, InstituteGradeSubjectModel } from "../../subject/models/subject-model";
import { StaffModel } from "../../auth";
import { StudentModel } from "../../student-management/models/student.model";

export class InstituteAcademicYear extends AppSignature {
    parentBoardID: string;
    parentInstituteID: string;
    academicYearFrom: string;
    academicYearTo: string;
}

export class InstituteAcademicYearDTO {
    board: Board = new Board();
    instituteAcademicYear: InstituteAcademicYear = new InstituteAcademicYear();
    gradeDivisions: Array<InstituteGradeDivisionDTO> = new Array<InstituteGradeDivisionDTO>;
}

export class InstituteGradeDivision extends AppSignature {
    parentInstituteAcademicYearID: string;
    parentGradeID: string;
    name: string;
    sortOrder: number;
    classTeacherID: string;
}

export class InstituteGradeDivisionTeacherDTO {
    classTeacher: StaffModel = new StaffModel();
    inUse: boolean = false;
    instituteGradeDivision: InstituteGradeDivision = new InstituteGradeDivision();
}

export class InstituteGradeDivisionDTO {
    grade: GradeModel = new GradeModel();
    subjects: Array<GradeSubjectDTO> = new Array<GradeSubjectDTO>();
    instituteAcademicYear: InstituteAcademicYear = new InstituteAcademicYear();
    instituteGradeDivisionClassTeachers: Array<InstituteGradeDivisionTeacherDTO> = new Array<InstituteGradeDivisionTeacherDTO>;
}


export class GradeDivisionTeacherModel extends InstituteGradeDivisionTeacherDTO {
    grade: GradeModel = new GradeModel();
    hasClassTeacher: boolean = false;
}

// export class InstituteStaffSubjectMapView {
//     gradeSubjectModals: Array<SubjectMapGradeSubjectModal> = new Array<SubjectMapGradeSubjectModal>();
//     staffSubjectDivisionMaps: Array<GradeDivisionSubjectStaffDTO> = new Array<GradeDivisionSubjectStaffDTO>();
// }

export class SubjectMapGradeSubjectModal {
    staffSubjectMap: InstituteStaffSubjectMap = new InstituteStaffSubjectMap();
    instituteGradeSubject: InstituteGradeSubjectModel = new InstituteGradeSubjectModel();
}

export class InstituteStaffSubjectMap extends AppSignature {
    parentStaffID: string;
    parentInstituteGradeSubjectID: string;
}


export class GradeDivisionStaffSubjectMapModal {
    instituteGradeDivision: InstituteGradeDivision = new InstituteGradeDivision();
    instituteStaffSubjectMaps: Array<SubjectMapGradeSubjectModal> = new Array<SubjectMapGradeSubjectModal>();
}

export class InstituteGradeDivisionSubjectStaffMap extends AppSignature {
    parentInstituteStaffSubjectMapID: string;
    parentInstituteGradeDivisionID: string;
}

export class GradeDivisionSubjectStaffDTO {
    divisionSubjectStaffMap: InstituteGradeDivisionSubjectStaffMap = new InstituteGradeDivisionSubjectStaffMap();
    instituteAcademicYear: InstituteAcademicYear = new InstituteAcademicYear();
}

export class GradeDivisionSubjectModel {
    parentGradeID: string;
    parentDivisionID: string;
    parentSubjectID: string;
    parentModuleID: string;
    parentGradeDivisionSubjectStaffMapID: string;
}

export class TeacherGradeDivisionSubjectModal {
    subjects: Array<InstituteGradeSubjectModel> = new Array<InstituteGradeSubjectModel>();
    classTeacherDivisions: Array<InstituteGradeDivision> = new Array<InstituteGradeDivision>();
    teacherGradeDivisionSubjects: Array<GradeDivisionSubjectModel> = new Array<GradeDivisionSubjectModel>();
}

export class InstituteGradeDivisionView {
    board: Board = new Board();
    grade: GradeModel = new GradeModel();
    division: InstituteGradeDivision = new InstituteGradeDivision();
    academicYear: InstituteAcademicYear = new InstituteAcademicYear();
    classTeacher: StaffModel = new StaffModel();
    students: Array<StudentModel> = [];
    subjects: Array<InstituteGradeSubjectModel> = new Array<InstituteGradeSubjectModel>();
}